import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FivaLayout from "../Layout/FivaLayout";
import CookiesComponent from "../components/CookiesComponent/CookiesComponent";
import HeadComponent from "../components/HeadComponent/HeadComponent";
var Cookies = function() {
    var headerProps = {
        title: "Pol\xedtica de cookies",
        keywords: "Asesor\xeda energ\xe9tica, Consultor\xeda energ\xe9tica, Optimizaci\xf3n energ\xe9tica, \n        Asesoramiento el\xe9ctrico, Renovables, energ\xedas Renovables, eficiencia energ\xe9ticas,\n        consultor\xeda de software, asesoramiento de software, Comparativa de Tarifas, Comparativa de Energ\xe9tica,\n        Comparativa de luz, Comparativa de luz y gas, Comparativa de gas",
        content: "Pol\xedtica de cookies de Fiva, en Fiva te informamos sobre el uso completo de tus datos"
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(CookiesComponent, {})
        ]
    });
};
export default Cookies;
